/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantChatPostRequestMessagePartsInnerAnyOf3Approval
 */
export interface AssistantChatPostRequestMessagePartsInnerAnyOf3Approval {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInnerAnyOf3Approval
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssistantChatPostRequestMessagePartsInnerAnyOf3Approval
     */
    approved?: boolean;
}

/**
 * Check if a given object implements the AssistantChatPostRequestMessagePartsInnerAnyOf3Approval interface.
 */
export function instanceOfAssistantChatPostRequestMessagePartsInnerAnyOf3Approval(value: object): value is AssistantChatPostRequestMessagePartsInnerAnyOf3Approval {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalFromJSON(json: any): AssistantChatPostRequestMessagePartsInnerAnyOf3Approval {
    return AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalFromJSONTyped(json, false);
}

export function AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantChatPostRequestMessagePartsInnerAnyOf3Approval {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'approved': json['approved'] == null ? undefined : json['approved'],
    };
}

export function AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalToJSON(json: any): AssistantChatPostRequestMessagePartsInnerAnyOf3Approval {
    return AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalToJSONTyped(json, false);
}

export function AssistantChatPostRequestMessagePartsInnerAnyOf3ApprovalToJSONTyped(value?: AssistantChatPostRequestMessagePartsInnerAnyOf3Approval | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'approved': value['approved'],
    };
}

